"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useStorage_1 = require("./useStorage");
// wrapper around useLocalStorage that only starts tracking the state once you set
// value (defaultValue doesn't persist)
const usePref = (key, defaultValue) => {
    const [value, setValue] = useStorage_1.useLocalStorage(key);
    return [value != null ? value : defaultValue, setValue];
};
usePref.reset = useStorage_1.useLocalStorage.reset;
exports.default = usePref;
//# sourceMappingURL=usePref.js.map